import GovtDepartment from "../models/govtDepartment";

export default class GovtDepartmentFactory {
  static createFromJson(json: any): GovtDepartment {
    return new GovtDepartment(json);
  }

  static createFromJsonArray(jsonArray: any[]): GovtDepartment[] {
    const jsonData: GovtDepartment[] = [];
    jsonArray.forEach((item) => {
      jsonData.push(GovtDepartmentFactory.createFromJson(item));
    });

    return jsonData;
  }
}
